import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Auth from './components/Auth';
import ChatBot from './components/ChatBot';
import CreditPurchase from './components/CreditPurchase';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './components/Home';
import './App.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const hideHeaderFooter = location.pathname === '/'; // Hide header/footer on login page

  return (
    <div className="app-layout">
      {!hideHeaderFooter && <Header />}
      <main className={`main-content ${!hideHeaderFooter ? 'with-header-footer' : ''}`}>
        {children}
      </main>
      {!hideHeaderFooter && <Footer />}
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Layout>
          <Routes>
            {/* Public auth page as landing */}
            <Route path="/" element={<Auth />} />

            {/* Home and app pages require auth */}
            <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />

            <Route
              path="/chat"
              element={
                <ProtectedRoute>
                  <ChatBot />
                </ProtectedRoute>
              }
            />

            <Route
              path="/credits"
              element={
                <ProtectedRoute>
                  <CreditPurchase />
                </ProtectedRoute>
              }
            />

            {/* Optional placeholders for tiles; replace when you build pages */}
            <Route
              path="/kundli"
              element={
                <ProtectedRoute>
                  <div style={{ padding: 20 }}>Kundli page coming soon…</div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pooja"
              element={
                <ProtectedRoute>
                  <div style={{ padding: 20 }}>Pooja booking coming soon…</div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/moon"
              element={
                <ProtectedRoute>
                  <div style={{ padding: 20 }}>Moon tracker coming soon…</div>
                </ProtectedRoute>
              }
            />

            {/* Fallback: if unknown route, go to /home when logged in */}
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  );
}

export default App;
